import { useContext } from 'react';

import { FormConfigType } from '../@types';
import { PaymentCardFormContext } from '../contexts';

const DefaultFormConfig: FormConfigType = {
  cardFields: {},
  contactFields: {},
  billingFields: {},
};

export const useFormConfig = (): FormConfigType => {
  const ctx = useContext(PaymentCardFormContext);

  return { ...DefaultFormConfig, ...ctx?.formConfig };
};
